import { AlertCircle, LoaderCircle } from "lucide-react";
import type { ReactNode } from "react";

type ApiStateProps = {
  /** `loading` mostra o giro; `error` pinta de vermelho. */
  kind: "loading" | "error";
  children: ReactNode;
  /** Quando a falha é recuperável clicando de novo. Só faz sentido com
   * `kind="error"` — num carregamento em voo não há o que retentar. */
  onRetry?: () => void;
};

/** "A consulta está em voo" e "a consulta falhou", nas duas telas.
 *
 * Havia DUAS linguagens pra mesma coisa. A `.api-state` (menções,
 * relatórios, uploads) montava o giro à mão em cada ponto; as telas de
 * admin usavam `.copiloto-empty-list` — uma classe de LISTA VAZIA — pra
 * dizer "Carregando modelos…", sem giro nenhum. Quem abria a tela de
 * modelos de IA num dia lento via um texto cinza parado, indistinguível
 * de "não há modelos cadastrados", que é a outra coisa que aquela classe
 * diz.
 *
 * Essa confusão é o motivo de o componente cobrir só os dois estados de
 * REQUISIÇÃO: `.copiloto-empty-list` continua existindo e volta a
 * significar uma coisa só — a lista está vazia, e isso é a resposta,
 * não um estado de espera. */
export function ApiState({ kind, children, onRetry }: ApiStateProps) {
  return (
    <div className={kind === "error" ? "api-state error" : "api-state"}>
      {/* Forma além de cor: o vermelho sozinho não chega a quem não o
          distingue, e três das cinco telas já traziam este ícone. */}
      {kind === "error" ? (
        <AlertCircle size={18} />
      ) : (
        <LoaderCircle size={18} className="spin" />
      )}
      {children}
      {onRetry && (
        <button type="button" onClick={onRetry}>
          Tentar de novo
        </button>
      )}
    </div>
  );
}
